(ns guidebook.views.our-process
  (:require
   [cljss.core :as cljss]
   [css.core
    :refer [get-theme defstyled]]))

(defstyled header-s :div
  {:display "grid"
   :grid-template-columns "3fr 7fr"
   :width "100%"
   :align-items "flex-start"
   ::cljss/media {[:print]
                  {:grid-template-columns "45% 55%"}}})

(defstyled header-tags-s :div
  {:background (get-theme :primary)
   :color "white"
   :z-index "1"
   :padding "128px 100px"
   ::cljss/media {[:print]
                  {:padding "115px 100px"}}})

(defstyled tag-s :h2
  {:font-size "62px"
   :font-weight "300"
   :color "white"
   :line-height "80px"
   ::cljss/media {[:print]
                  {:font-size "58px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0}}})

(defstyled header-title-wrapper-s :div
  {:background "black"
   :display "flex"
   :align-items "flex-end"
   :flex-direction "column"
   :position "relative"
   :left "-50px"
   :padding "82px 100px 100px"
   ::cljss/media {[:print]
                  {:top "50px"
                   :padding "72px 100px"}}})


(defstyled header-title-s :div
  {:width "680px"
   ::cljss/media {[:print]
                  {:width "auto"}}})

(defstyled title-s :h1
  {:font-size "94px"
   :font-weight 300
   :text-transform "uppercase"
   :margin-bottom "2rem"
   :max-width "970px"
   :line-height "110px"
   :text-align "right"
   :color "white"
   ::cljss/media {[:print]
                  {:text-align "left"
                   :font-size "68px"
                   :line-height "80px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-bottom "2rem"}}})

(defstyled header-body-s :div
  {:text-align "right"
   :color "white"
   :font-size "25px"
   :font-weight 300
   :margin-bottom "36px"
   :line-height "36px"
   :&:last-child {:margin-bottom "0"}
   ::cljss/media {[:print]
                  {:text-align "left"
                   :font-size "20px"
                   :line-height "32px"}}})

(defn header []
  [header-s
   [header-tags-s
    [tag-s "Wealth"]
    [tag-s "Designed."]
    [tag-s "Life Defined."]]
   [header-title-wrapper-s
    [header-title-s
     [title-s "Our Process"]
     [header-body-s "Your financial future requires more than luck and timing. We work with you to take actions appropriate for your stage in life so your plan remains constantly tailored to your life."]
     [header-body-s "We are hear with you to help you see around corners and take advantage of opportunities that increase the value of your life."]]]])

(defstyled card-title-s :h3
  {:font-size "32px"
   :height "39px"
   :font-weight "500"
   ::cljss/media {[:print]
                  {:font-size "28px"
                   :line-height "28px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0}}})

(defstyled card-list-s :ul
  {:list-style "disc"
   :margin "0 0 0 2rem"
   ::cljss/media {[:print]
                  {:margin "0 0 2rem 0"
                   :padding "0"
                   :list-style-position "inside"}}})

(defstyled card-list-item-s :li
  {:font-size "25px"
   :font-weight 300
   :line-height "36px"
   :margin-top "15px"
   :&:first-child {:margin-top "20px"}
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :line-height "32px"
                   :margin-top "8px"
                   :&:first-child {:margin-top "12px"}}}})

(defn card [{:keys [title, items]}]
  [:div
   [card-title-s title]
   (into [card-list-s] (map #(card-list-item-s %)) items)])

(def discover
  {:title "Discover"
   :items ["Understand your life and purpose"
           "Understand where you're at today"
           "Understand your financial priorities"
           "Assess your tolerance for risk"]})

(def design
  {:title "Design"
   :items ["Analyze your future cashflow needs"
           "Map savings and earnings goals to financial priorities"
           "Allocate your capital using proprietary strategies"
           "Stress test future scenarios before investing"
           "Calculate the rate of return you need to achieve your goals"
           "Show you where you stand against your peers"]})

(def define
  {:title "Define"
   :items ["Assess your insurance health"
           "Rebalance and reallocate as your life changes"
           "Analyze holistically to assure tax efficiency"
           "Establish a Focused Financial Plan"]})

(defstyled cards-s :div
  {:display "grid"
   :grid-template-columns "2fr 3fr 2fr"
   :grid-gap "60px"
   :padding "30px 100px 115px"
   ::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "column"
                   :padding "30px 100px 0"}}})

(defstyled process-s :div
  {:min-height "100vh"})

(defn main []
  [process-s
   [header]
   [cards-s
    [card discover]
    [card design]
    [card define]]])
